import { selectConsent } from "@/store/slices/cookieConsentSlice";
import { useGetSignedBeaconIdentityV1GetQuery } from "@/store/baseClientApi";
import { Beacon, getBeaconSessionConsent } from "@/utils/beacon";
import { useEffect } from "react";
import { useSelector } from "react-redux";

export const useIdentifyBeacon = () => {
  const { data } = useGetSignedBeaconIdentityV1GetQuery();
  const consent = useSelector(selectConsent);

  useEffect(() => {
    if (data !== undefined && (consent === "all" || getBeaconSessionConsent())) {
      Beacon("identify", {
        email: data.user_email ?? "",
        name: data.user_name,
        jobTitle: data.role_name ?? undefined,
        "organisation-id": Number(data.org_id),
        "organisation-name": data.org_name,
        signature: data.signed_hash
      });
    }
  }, [data, consent]);

  return <></>;
};
